export default "__VITE_ASSET__MCN4sbyy__"